import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import BidFormValuesPresenter from 'presenters/BidFormValuesPresenter';
import BidFormValueField from './components/BidFormValueField';

import useStyles from './useStyles';

const AutoCalculation = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { bidFormValues } = props;

  return (
    <Box className={classes.container}>
      <Typography variant="h2">{t('components.LoanOptions.BidPage.AutoCalculation.header')}</Typography>
      <Box width="100%" display="flex" flexWrap="wrap" mt={1} justifyContent="space-between">
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.pi')}
          value={BidFormValuesPresenter.formattedPi(bidFormValues)}
          prefix="$"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.mIrate')}
          value={BidFormValuesPresenter.mIrate(bidFormValues)}
          suffix="%"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.mi')}
          value={BidFormValuesPresenter.formattedMi(bidFormValues)}
          prefix="$"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.piMi')}
          value={BidFormValuesPresenter.formattedPiMi(bidFormValues)}
          prefix="$"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.propertyTaxVal')}
          value={BidFormValuesPresenter.formattedPropertyTaxVal(bidFormValues)}
          prefix="$"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.hazardInsuranceVal')}
          value={BidFormValuesPresenter.formattedHazardInsuranceVal(bidFormValues)}
          prefix="$"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.assessments')}
          value={BidFormValuesPresenter.formattedAssessments(bidFormValues)}
          prefix="$"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.estimatedTaxes')}
          value={BidFormValuesPresenter.formattedEstimatedTaxes(bidFormValues)}
          prefix="$"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.estimatedTotalMonthlyPayment')}
          value={BidFormValuesPresenter.formattedEstimatedTotalMonthlyPayment(bidFormValues)}
          prefix="$"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.apr')}
          value={BidFormValuesPresenter.apr(bidFormValues)}
          suffix="%"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.fiveYearsTotal')}
          value={BidFormValuesPresenter.formattedFiveYearsTotal(bidFormValues)}
          prefix="$"
        />
        <BidFormValueField
          label={t('components.LoanOptions.BidPage.AutoCalculation.fiveYearsPrincipalPaid')}
          value={BidFormValuesPresenter.formattedFiveYearsPrincipalPaid(bidFormValues)}
          prefix="$"
        />
      </Box>
    </Box>
  );
};

AutoCalculation.propTypes = {
  bidFormValues: BidFormValuesPresenter.shape().isRequired,
};

export default AutoCalculation;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/components/AutoCalculation/AutoCalculation.js